import { Button } from 'antd';
import { useCompanyContext } from 'contexts/CompanyContext';
import { CongratulationsImage } from 'icons/CongratulationsImage';
import { Link, useNavigate } from 'react-router-dom';

function StepSuccess() {
  const { companyConfig } = useCompanyContext();
  const navigate = useNavigate();

  return (
    <div className="success-block">
      <div className="block-center">
        <h2>Thank You!</h2>
        <CongratulationsImage color={companyConfig.colorPrimary} />
        <p>
          You will now be able to see and edit the message in the <Link to={'/dashboard'}>Dashboard</Link> page.
        </p>
        <p>If you have any questions or need any assistance, don't hesitate to reach out.</p>
        <p>Thanks again for choosing {companyConfig.companyName}!</p>
        <Button type="primary" size="large" onClick={() => navigate('/message')}>
          Create new message
        </Button>
      </div>
    </div>
  );
}

export default StepSuccess;
